export const phoneNumberRegex = "^\\+?([ -]*\\d){11,13}$";
// E.164: mandatory "+", country code not starting with 0, max 15 digits (spaces/dashes are stripped by normalizePhoneNumber)
export const e164PhoneNumberRegex = "^\\+[1-9]([ -]*\\d){6,14}$";
export const normalizePhoneNumber = (phoneNumber: string): string => {
  if (phoneNumber.length === 0) {
    return phoneNumber;
  }
  const withoutWhitespace = phoneNumber.replace(/\s+/g, '');
  const withoutDashes = withoutWhitespace.replace(/-/g, '');
  const withPlusInFront = phoneNumber.charAt(0) === '+' ? withoutDashes : '+' + withoutDashes;
  return withPlusInFront;
}
